import { type AppNode } from '../../types';

/** Lowest z-index image in a group — treated as the smart-resize base/background layer. */
export const getSmartResizeBaseImageId = (members: AppNode[]): string | undefined => {
  let baseImageId: string | undefined;
  let lowestZIndex = Number.POSITIVE_INFINITY;

  for (const member of members) {
    if (member.type !== 'image') {
      continue;
    }

    const zIndex = member.zIndex ?? 0;

    if (baseImageId === undefined || zIndex < lowestZIndex) {
      baseImageId = member.id;
      lowestZIndex = zIndex;
    }
  }

  return baseImageId;
};

/** Clears smartResizeFormatId from non-base image layers in split resize groups. */
export const stripSmartResizeFormatIdFromOverlayLayers = (nodes: AppNode[]): void => {
  const membersByGroup = new Map<string, AppNode[]>();

  for (const node of nodes) {
    if (!node.groupId || node.type !== 'image' || node.data.type !== 'image') {
      continue;
    }

    const members = membersByGroup.get(node.groupId) ?? [];
    members.push(node);
    membersByGroup.set(node.groupId, members);
  }

  for (const members of membersByGroup.values()) {
    if (members.length < 2) {
      continue;
    }

    const baseImageId = getSmartResizeBaseImageId(members);

    for (const member of members) {
      if (
        member.type !== 'image' ||
        member.data.type !== 'image' ||
        member.id === baseImageId ||
        member.data.smartResizeFormatId === undefined
      ) {
        continue;
      }

      member.data = { ...member.data, smartResizeFormatId: undefined };
    }
  }
};
